var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModelBlankExample(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12910",
    "data-name": "Group 12910",
    transform: "translate(-175 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5202",
    "data-name": "Group 5202",
    transform: "translate(-714.615 2.759)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 80,
    height: 80,
    rx: 13,
    transform: "translate(889.615 296.241)",
    fill: "#f4f7fd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9900",
    "data-name": "Path 9900",
    d: "M14-33.5V-42H1.5A1.5,1.5,0,0,0,0-40.5v29A1.5,1.5,0,0,0,1.5-10h21A1.5,1.5,0,0,0,24-11.5V-32H15.5A1.5,1.5,0,0,1,14-33.5Zm10-.881a1.5,1.5,0,0,0-.438-1.056l-6.119-6.125A1.5,1.5,0,0,0,16.381-42H16v8h8Z",
    transform: "translate(203 365)",
    fill: "#d5dee8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelBlankExample);
export default __webpack_public_path__ + "static/media/ModelBlankExample.2c874cc5c437c3ac125a90d54fe3b1f3.svg";
export { ForwardRef as ReactComponent };